<template>
  <div class="common-chart-legend">
    <span
      v-for="(legendValue, index) in legendValues"
      :key="`legend-badge-${index}`"
      class="legend-wrapper"
    >
      <span :style="{ 'background-color': legendValue.color }" class="badge"></span>
      <span>{{ legendValue.label }}</span>
      <CommonChip transparent v-if="props.lowestPercentage?.includes(index)">
        A staffer
      </CommonChip>
    </span>
  </div>
</template>

<script setup lang="ts">
import CommonChip from './CommonChip.vue'

const props = withDefaults(
  defineProps<{
    legendValues: Array<{ label: string; color?: string }>
    lowestPercentage?: number[]
  }>(),
  {}
)
</script>

<style scoped>
.common-chart-legend {
  display: flex;
  flex-direction: column;
  gap: 14px;
  justify-content: center;
}

.legend-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.badge {
  border-radius: 5px;
  padding: 0;
  min-width: 21px;
  height: 21px;
  display: inline-block;
}

span {
  white-space: nowrap;
}
</style>
